import { can } from '@misumi/shared'
import { Link } from 'react-router-dom'
import { roleLabel } from '../components/admin/roleLabels'
import { useAuth } from '../lib/auth/auth-context'

/**
 * Account settings (UID-343). Minimal stub: the account-menu dropdown's
 * "Account settings" item (`Fictiv Platform.dc.html` account menu,
 * `onAcctSettings`) had no destination in the app — this gives it one.
 * Also hosts the "Manage users" and "Billing" destinations that UID-343
 * removed from the account-menu dropdown itself (the design's dropdown has
 * no equivalent items there), so neither becomes unreachable — Billing and
 * Manage users have no other nav entry point in the app.
 *
 * Identity block reuses the same session fields the account-menu header
 * already shows (`TopBar.tsx`'s `AccountMenu`) — name, email, role.
 */
export function AccountSettingsPage() {
  const auth = useAuth()

  if (auth.status === 'loading') {
    return null
  }

  if (auth.status !== 'authenticated') {
    return (
      <section className="auth-page">
        <h1 className="display-heading">Sign in to view account settings</h1>
        <p>We need to confirm it&rsquo;s you before showing your account settings.</p>
        <p>
          <Link to="/login">Sign in</Link>
        </p>
      </section>
    )
  }

  const { displayName, email, accountContext } = auth.session
  const isAccountAdmin = can(accountContext.role, 'user:manage')

  return (
    <section>
      <h1 className="display-heading">Account settings</h1>
      <dl>
        <dt>Name</dt>
        <dd>{displayName || email}</dd>
        <dt>Email</dt>
        <dd>{email}</dd>
        <dt>Role</dt>
        <dd>{roleLabel(accountContext.role)}</dd>
      </dl>
      <ul>
        <li>
          <Link to="/account/billing">Billing</Link>
        </li>
        {isAccountAdmin && (
          <li>
            <Link to="/admin/users">Manage users</Link>
          </li>
        )}
      </ul>
    </section>
  )
}
